import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { FunctionComponent } from 'react';
import ComputingDisplay from './ComputingDisplay';
import { LayoutStyles } from '../automotivePage/AutomotiveOverviewPage';
import type { ApplicationsContent } from '../../graphql/pimcore/modules/siteContent/types/ApplicationsContent';
import { InternalLinkSection } from '../common/internalLinkSection';
import { GetResponsiveWidth } from '../common/TabsComponent';

interface ComputingOverviewPageProps {
    contentTree: ApplicationsContent;
}
const ComputingOverviewPage: FunctionComponent<ComputingOverviewPageProps> = ({ contentTree }) => {
    const { temperatureSensorLinks } = contentTree.ComputingAndEnterpriseSystems;
    const hasTemperatureSensorLinks = temperatureSensorLinks.links.length > 0;
    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    overflowY: 'hidden',
                    backgroundColor: '#F2F2F2',
                }}
            >
                <Box sx={LayoutStyles}>
                    <Typography sx={{ fontFamily: 'Poppins', fontSize: '24px', fontWeight: 700 }}>
                        {contentTree.ComputingAndEnterpriseSystems.overviewTitle.content}
                    </Typography>
                    <Box
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '16px',
                            fontWeight: 400,
                            lineHeight: '24px',
                            marginTop: '1.5rem',
                            marginBottom: '2rem',
                        }}
                        dangerouslySetInnerHTML={{
                            __html: contentTree.ComputingAndEnterpriseSystems.overviewMainText
                                .sanitizedContent,
                        }}
                    />
                </Box>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    overflowY: 'hidden',
                    backgroundColor: 'white',
                }}
            >
                <Box sx={{ ...LayoutStyles, marginBottom: '2rem' }}>
                    <ComputingDisplay contentTree={contentTree} />
                </Box>
            </Box>
            {hasTemperatureSensorLinks ? (
                <InternalLinkSection
                    section={temperatureSensorLinks}
                    contentPadding={{
                        width: GetResponsiveWidth,
                        margin: 'auto',
                        alignItems: 'flex-start',
                    }}
                />
            ) : null}
            <Box sx={{ backgroundColor: 'white', height: '10px' }}></Box>
        </>
    );
};

export default ComputingOverviewPage;
